import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import noop from 'lodash/noop';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import { Flyout } from '@els/els-react--flyout';
import { LinkElement } from '@els/els-react--link-element';
import { ButtonWithIcon } from '@els/els-react--button';
import UserDatabases from '@Services/UserDatabases';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ReactionCitationsComponent from '@Components/Results/reactions/reaction-details/reaction-citations.component';
import Catalyst from '@Services/Catalyst';

export default class ConditionsReferenceExperimentComponent extends React.Component {
  getExperimentalDataSheet() {
    const { detail } = this.props;
    return (
      <ul>
        {detail.fullTextLinkEntities.map((fullText) => (
          <li key={fullText.link}>
            <LinkElement
              href={fullText.link}
              isExternal
              className="stage-experimental-procedure__dropdown_item"
              onClick={() => {
                this.experimentalDataSheetLinkClick(fullText);
              }}>
              {fullText.type}
            </LinkElement>
          </li>
        ))}
      </ul>
    );
  }

  experimentalDataSheetLinkClick = (fullText) => {
    const { metadata, detail } = this.props;
    const dbName = UserDatabases.getDbName(get(metadata, 'databaseId'));
    const experimentId = get(detail, 'experiment');

    const link = {
      location: fullText.link,
      name: fullText.type,
    };
    const content = {
      id: `linkout:${experimentId}`,
      type: `${Catalyst.getPrefix()}:linkout:${dbName}:experimental data sheet`,
    };

    Catalyst.trackLinkOut(content, link);
  };

  getScientistHtml = () => {
    const { detail } = this.props;
    const { scientist } = detail;
    if (!scientist) {
      return '';
    }

    return isArray(scientist) ? `${scientist.join('; ')};` : `${[].join('; ')};`;
  };

  render() {
    const { metadata, detail, onAbstractOpen, onFullTextLinkClick, onIssueCitedCounterClick, index, onAuthorClick } = this.props;
    const { citations, elnCitation, experiment, producer, project, created, modified, fullTextLinkEntities } = detail;
    const scientistHtml = this.getScientistHtml();

    return (
      <>
        {(!isEmpty(citations) || elnCitation) && (
          <div className="references-block" data-testid="references-block">
            {citations &&
              citations.map((citation, citationIndex) => (
                <ReactionCitationsComponent
                  metadata={metadata}
                  // eslint-disable-next-line react/no-array-index-key
                  key={citationIndex}
                  index={index}
                  citation={citation}
                  onFullTextLinkClick={onFullTextLinkClick}
                  onIssueCitedCounterClick={onIssueCitedCounterClick}
                  onAbstractOpen={onAbstractOpen}
                  onAuthorClick={onAuthorClick}
                />
              ))}
            {elnCitation && <InnerHTML tag="div" html={elnCitation} extendedTags />}
          </div>
        )}
        {!isEmpty(experiment) && (
          <div className="ci-reaction-details" data-testid="ci-reaction-details">
            <span className="ci-details-header">Experiment</span>
            <div className="ci-details-group">
              {!isEmpty(producer) && (
                <div>
                  <b>Producer: </b> <InnerHTML tag="span" html={producer} extendedTags />
                </div>
              )}
              <div>
                <b>Scientist: </b> <InnerHTML tag="span" html={scientistHtml} extendedTags />
              </div>
              <div>
                <b>Experiment ID: </b> <InnerHTML tag="span" html={experiment} extendedTags />
              </div>
              <div>
                <b>Project: </b> <InnerHTML tag="span" html={project} extendedTags />
              </div>
              <div>
                <b>Created: </b> <InnerHTML tag="span" html={created} extendedTags />
              </div>
              <div>
                <b>Modified: </b> <InnerHTML tag="span" html={modified} extendedTags />
              </div>
            </div>
            {!isEmpty(fullTextLinkEntities) && (
              <Flyout
                className="stage-experimental-procedure"
                flyout={
                  <div className="u-els-font-size-base u-els-color-text u-els-margin-right-2x">
                    <div className="u-els-margin-bottom-1o2 u-els-font-size-h4 u-els-nowrap">Available through</div>
                    {this.getExperimentalDataSheet()}
                  </div>
                }
                shouldCloseOnESC
                showCloseButton
                placement="bottom-end"
                pointerType="primary">
                <ButtonWithIcon
                  sprite="ChevronDown"
                  type="link"
                  linkIconSize="xs"
                  iconRight
                  className="e2e-available-through"
                  onClick={noop}>
                  Experimental Data Sheet
                </ButtonWithIcon>
              </Flyout>
            )}
          </div>
        )}
      </>
    );
  }
}

ConditionsReferenceExperimentComponent.defaultProps = {
  onFullTextLinkClick: () => null,
  onIssueCitedCounterClick: () => null,
  onAbstractOpen: () => null,
  onAuthorClick: () => null,
};

ConditionsReferenceExperimentComponent.propTypes = {
  metadata: MetadataPropTypesShape,
  detail: PropTypes.object.isRequired,
  index: PropTypes.string.isRequired,
  onFullTextLinkClick: PropTypes.func,
  onIssueCitedCounterClick: PropTypes.func,
  onAbstractOpen: PropTypes.func,
  onAuthorClick: PropTypes.func,
};
